module.exports = __webpack_public_path__ + "static/media/CreateFolder.9f5a9f80.svg";